import type { FaireProductEntity } from "../../entity_types/product";

export const p_3bumn48kac: FaireProductEntity = {
  token: "p_3bumn48kac",
  type: "product",
  name: "Kid/Baby 2-Tone Cap: It's a Bad Day to Be a Hot Dog",
  brandToken: "b_ee3ulfd69w",
  brandName: "Funky Junque",
  imageUrl:
    "https://cdn.faire.com/fastly/17bcccef9d4441519e3ad6c285481ff165660046bfccce414b1baf08f747ce8d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4cddb54873b30cd1f65b69684d7932bc666f12f947bf43e4514e96363e8f4f8.jpeg",
    "https://cdn.faire.com/fastly/7e2a67723c27a103c430db21c7b1b702d00c7b462b25e6fec32f4f83a53c3ce9.jpeg",
    "https://cdn.faire.com/fastly/458fbdf3c8d7133b6114a62505deec076b2387e085a62a95014dd5b78365d009.jpeg",
    "https://cdn.faire.com/fastly/d0f40a1e6d4c97bb9ef1d0797c7179c2cbb5ee7e9198a8f55a12d981a3c0b987.jpeg",
    "https://cdn.faire.com/fastly/edda929832d83501422cb693238d42ba759e471adad109b2cd81cacf6f790dd0.jpeg",
    "https://cdn.faire.com/fastly/fbbda5033ecc3a0644320e60c2f3b20bc997f3bfa091cdce08822ef8389b4a23.jpeg",
  ],
  priceDollars: 11,
  description:
    "Made from 35% cotton and 65% polyester, this kids & infant baseball cap offers durability, comfort, and a stylish two-tone vintage design. Ideal for pairing with baby boy outfits or toddler essentials, it’s perfect for newborns and kids alike. Designed to protect delicate heads, it provides a snug, breathable fit and shields against the sun for year-round safety. The adjustable snapback ensures a customizable fit for growing children, available in three sizes: X-Small (0-12 months), Small (12-24 months), and Medium/Large (2-9 years). Whether as a baby baseball cap, toddler trucker hat, or youth snapback, this versatile accessory combines practicality, comfort, and style for all occasions.",
  tags: [],
  msrpDollars: 21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:57.667Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
